import { render, staticRenderFns } from "./FormSaveNomenclatureByProviderAndDate.vue?vue&type=template&id=08f0ff25&scoped=true&"
import script from "./FormSaveNomenclatureByProviderAndDate.vue?vue&type=script&lang=js&"
export * from "./FormSaveNomenclatureByProviderAndDate.vue?vue&type=script&lang=js&"
import style0 from "./FormSaveNomenclatureByProviderAndDate.vue?vue&type=style&index=0&id=08f0ff25&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0ff25",
  null
  
)

export default component.exports